var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDinersClub = function SvgDinersClub(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      height: 20,
      width: 32,
      userSelect: "none"
    },
    viewBox: "0 0 32 21"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "diners"
  }, /*#__PURE__*/React.createElement("g", {
    id: "card",
    transform: "translate(0 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "shape",
    fill: "#EBF1F8",
    d: "M26.58 19H2.42A2.4 2.4 0 0 1 0 16.62V2.38A2.4 2.4 0 0 1 2.42 0h24.16A2.4 2.4 0 0 1 29 2.38v14.25A2.4 2.4 0 0 1 26.58 19z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "shape",
    fill: "#0165AC",
    d: "M12 2.02V2h5v.02a7.5 7.5 0 0 1 0 14.96V17h-5v-.02a7.5 7.5 0 0 1 0-14.96z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "shape",
    fill: "#FFFFFF",
    d: "M14 13.74a4.5 4.5 0 0 0 0-8.48v8.48zm-3-8.48a4.5 4.5 0 0 0 0 8.48V5.26zM12.5 16a6.5 6.5 0 1 1 0-13 6.5 6.5 0 0 1 0 13z"
  }))))));
};
export { SvgDinersClub as ReactComponent };